let ol = require('openlayers');
let defStyle = new ol.style.Style({
  image: new ol.style.RegularShape({
    fill: new ol.style.Fill({color: "rgba(0,100,255,0.3)"}),
    points: 12,
    radius: 30,
    angle: Math.PI / 4
  })
});

let SelectResult = require('./selectResult');

class Select {
  constructor(params) {
    /*    params.style = function (feature, resolution) {
          let featureStyle = feature.layer.layer.getStyleFunction();
          let storedStyle = feature.layer.getStyle();
          let value = featureStyle(feature) || defStyle;
          return value;
        };*/
    let interaction = new ol.interaction.Select(params);
    this.interaction = interaction;
    this.type = "select";
    this.id = "map";
    this.events = {};
    this.initEvents(params);
  }

  initEvents(params) {
    let self = this;
    let interaction = self.interaction;
    self.interaction.on("select", (data) => {
      let result = data.selected.map((selectedFeature, index) => {

        let geometry = Object.assign({}, selectedFeature.getGeometry());
        let store = params.store;
        let layers = store.layers;

        let attributes = Object.assign({}, selectedFeature.getProperties());
        delete attributes.geometry;

        let layerId = interaction.getLayer(selectedFeature).getProperties().id;

        let layer = layers[layerId];

        let layerName = layer ? layer.store.alias : layerId;
        let fieldName = layer ? layer.getDisplayField() : "guid";
        let title = selectedFeature.get(fieldName) || "-";

        let item = new SelectResult({
          layer: layer,
          layerId: layerId,
          layerName: layerName,
          queryGeometry: geometry,
          geometry: geometry,
          attributes: attributes,
          dirtyData: selectedFeature,
          title: title,
          index: index
        });

        return item;
      });
      if (params.func) params.func(result);
    })
  }

  /**
   * Подписка на события
   * @param eventName
   * @param listener
   */
  on(eventName, listener) {
    let self = this;
    let eventStore = self.events;
    eventStore[eventName] = listener;
  }

  /**
   * Выключение подписки на событие
   * @param eventName
   */
  off(eventName) {
    let self = this;
    let eventStore = self.events;
    if (eventStore[eventName]) delete eventStore[eventName];
  }

  /**
   * Инициация события с контекстом
   * @param eventName
   * @param context
   */
  emit(eventName, context) {
    let self = this;
    let eventStore = self.events;
    let listener = eventStore[eventName];
    if (listener && typeof listener === "function") {
      listener(context);
    }
  }
}

module.exports = Select;